import "core-js/modules/es.array.find";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { welfareCollection, gmWelfareWhiteLists } from '@/api/gmtool/packageCode';
import { gmTool } from "@/mixins/index";
export default {
  mixins: [gmTool],
  props: {
    prod: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      paramsData: {
        role_id: '',
        amount: '',
        device_id: '',
        pay_id: ''
      },
      gmWelfareWhiteListsList: [],
      dialogShow: false,
      rules: {
        role_id: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        amount: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        pay_id: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      this.getLists();
      this.dialogShow = true;
    },
    getLists: function getLists() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return gmWelfareWhiteLists(_this.prod);

              case 2:
                _this.gmWelfareWhiteListsList = _context.sent.data;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    roleChange: function roleChange(e) {
      if (e) {
        this.paramsData.device_id = this.gmWelfareWhiteListsList.find(function (i) {
          return i.user_id == e;
        }).device_id;
      }
    },
    clearData: function clearData(isClearId) {
      this.paramsData = {
        role_id: '',
        amount: '',
        device_id: '',
        pay_id: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          welfareCollection(_objectSpread(_objectSpread({}, _this2.paramsData), _this2.prod)).then(function (res) {
            if (res.status == 200) {
              _this2.$message({
                message: _this2.$t('operationSuccess'),
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$emit('update');
            }
          });
        }
      });
    }
  }
};